<div [ngClass]="cssMediaService.deviceCss('statebutton')">
    <div *ngIf="bindToState" class="states">
        <div [class.selected]="state === 0" class="selection1">
            <label>{{ state1Title }}</label>
        </div>
        <div [class.selected]="state === 1" class="selection2">
            <label>{{ state2Title }}</label>
        </div>
    </div>
    <div *ngIf="!bindToState" class="states">
        <div [class.selected]="isFirstStateSelected" class="selection1">
            <label>{{ state1Title }}</label>
        </div>
        <div [class.selected]="!isFirstStateSelected" class="selection2">
            <label>{{ state2Title }}</label>
        </div>
    </div>
    <div [ngClass]="cssMediaService.deviceCss('imagebutton')">
        <div [class.pressed]="isPressed" class="inner">
            <img [alt]="title" [src]="source" [title]="title" height="32" width="32" />
            <label [hidden]="!cssMediaService.isDesktop">{{ title }}</label>
        </div>
    </div>
</div>
